module.exports = __webpack_public_path__ + "img/device-8.f4e0048a.png";